import * as React from 'react';
import styles from '../Pages/pageStyles.scss';

export const RecaptchaFailed: React.FunctionComponent = (): React.ReactElement => (
  <div className={styles.fieldError}>Failed to verify reCAPTCHA. Please reload page.</div>
);

export default RecaptchaFailed;
